const getBusinessStreet = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Address'] && business['Company Address'].ID) {
    if (business['Company Address'].Suite) {
      return `${business['Company Address'].Street} ${business['Company Address'].Suite}`;
    }
    return business['Company Address'].Street;
  }
  return null;
};

export default getBusinessStreet;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessStreet.js